module.exports = __webpack_public_path__ + "img/CM5SF.2ce47c0e.png";